import { useState } from "react";
import { hotTopics, hotRanges, type HotRange } from "@/mocks/gossip";

const rankStyles: Record<number, string> = {
  1: "bg-primary-500 text-background-50 dark:text-foreground-950",
  2: "bg-accent-500 text-background-50 dark:text-foreground-950",
  3: "bg-secondary-500 text-background-50 dark:text-foreground-950",
};

export default function HotBoard() {
  const [range, setRange] = useState<HotRange>("hour");
  const list = hotTopics[range];

  return (
    <section id="hot" className="w-full scroll-mt-20 bg-background-50 py-14 md:py-20">
      <div className="mx-auto w-full px-4 md:px-6">
        <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
          <div>
            <span className="inline-flex items-center gap-1.5 text-xs font-medium uppercase tracking-widest text-primary-600">
              <i className="ri-fire-line w-4 h-4 flex items-center justify-center" aria-hidden="true"></i>
              今日热议
            </span>
            <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">吃瓜热榜 · 现在大家在围观什么</h2>
            <p className="mt-2 max-w-2xl text-sm text-foreground-600">
              按热度实时聚合的热门讨论话题，切换时间维度查看不同阶段的热度排行。榜内仅汇总社区讨论方向，具体信息请以原始来源为准。
            </p>
          </div>

          <div
            className="inline-flex self-start rounded-full bg-background-100 p-1"
            role="tablist"
            aria-label="热榜时间范围"
          >
            {hotRanges.map((item) => (
              <button
                key={item.key}
                type="button"
                role="tab"
                aria-selected={range === item.key}
                onClick={() => setRange(item.key)}
                className={
                  "rounded-full px-4 py-1.5 text-sm transition-colors cursor-pointer whitespace-nowrap " +
                  (range === item.key
                    ? "bg-primary-500 text-background-50 dark:text-foreground-950"
                    : "text-foreground-700 hover:text-primary-700")
                }
              >
                {item.label}
              </button>
            ))}
          </div>
        </div>

        <ol className="mt-8 grid grid-cols-1 lg:grid-cols-2 gap-3 md:gap-4">
          {list.map((topic) => (
            <li
              key={topic.rank}
              className="group flex items-start gap-4 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-300"
            >
              <span
                className={
                  "flex items-center justify-center w-8 h-8 shrink-0 rounded-md font-heading text-sm font-bold " +
                  (rankStyles[topic.rank] ?? "bg-background-200 text-foreground-700")
                }
              >
                {topic.rank}
              </span>
              <div className="min-w-0 flex-1">
                <h3 className="text-sm md:text-base font-medium leading-snug text-foreground-950">{topic.title}</h3>
                <div className="mt-2 flex flex-wrap items-center gap-x-4 gap-y-1 text-xs text-foreground-500">
                  <span className="rounded bg-secondary-100 px-2 py-0.5 text-secondary-900">{topic.tag}</span>
                  <span className="flex items-center gap-1">
                    <i className="ri-fire-line w-3.5 h-3.5 flex items-center justify-center text-primary-500" aria-hidden="true"></i>
                    {topic.heat.toLocaleString()} 热度
                  </span>
                  <span className="flex items-center gap-1">
                    <i className="ri-chat-3-line w-3.5 h-3.5 flex items-center justify-center" aria-hidden="true"></i>
                    {topic.replies} 条讨论
                  </span>
                  <span className="flex items-center gap-1 text-accent-700">
                    <i className="ri-arrow-up-line w-3.5 h-3.5 flex items-center justify-center" aria-hidden="true"></i>
                    {topic.trend}
                  </span>
                </div>
              </div>
            </li>
          ))}
        </ol>

        <p className="mt-5 text-xs text-foreground-500">
          * 榜单每 10 分钟更新一次，热度为综合讨论量、回复数与浏览量的相对值，不代表内容真实性。
        </p>
      </div>
    </section>
  );
}